import React, {useState} from "react";
import {Button, Form, Input, notification} from "antd";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
import "./Login.css";
import {LoginService} from "../../services/LoginService";
import {jwtDecode} from "jwt-decode";
import {useAuth} from "../AuthService/AuthProvider";
import {useNavigate} from "react-router-dom";

const Login = () => {
    const navigate = useNavigate();
    const {setUser} = useAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const handleSubmit = async () => {
        try {
            const data = await LoginService.login(username, password);
            const token = data.token;

            localStorage.setItem("token", token);

            const decodedToken = jwtDecode(token);
            const role = decodedToken.role;
            const userId = decodedToken.userId;

            setUser({ id: userId, role });

            if (role === "[ROLE_ADMIN]") {
                navigate("/orders");
            } else {
                navigate("/");
            }
        } catch (error) {
            notification.error({
                message: "Login Failed",
                description:
                    error.response?.data ||
                    "An error occurred during login. Please try again.",
            });
        }
    };

    return (
        <div className="login-container">
            <Form className="login-form" onFinish={handleSubmit}>
                <h2 className="login-title">Login</h2>
                <Form.Item>
                    <Input
                        placeholder="Username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        autoComplete="username"
                    />
                </Form.Item>
                <Form.Item>
                    <Input.Password
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        iconRender={(visible) =>
                            visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                        }
                        autoComplete="current-password"
                    />
                </Form.Item>
                <Button type="primary" color="yellow" htmlType="submit" block>
                    Login
                </Button>
            </Form>
        </div>
    );
};

export default Login;
